import request from '@/utils/request'

// 获取最近的考试（按课程过滤）
export function getLatestExam(courseId) {
  return request({
    url: '/front/exam/latest',
    method: 'get',
    params: { courseId }
  })
}

// 获取考试详情
export function getExamDetail(examId) {
  return request({
    url: '/front/exam/' + examId,
    method: 'get'
  })
}

// 开始考试
export function startExam(examId) {
  return request({
    url: '/front/exam/start/' + examId,
    method: 'post'
  })
}

// 获取考试题目
export function getExamQuestions(examId) {
  return request({
    url: '/front/exam/questions/' + examId,
    method: 'get'
  })
}

// 提交考试
export function submitExam(data) {
  return request({
    url: '/front/exam/submit',
    method: 'post',
    data: data
  })
}

// 获取考试记录列表（分页）
export function getExamRecords(pageNum = 1, pageSize = 10) {
  return request({
    url: '/front/exam/records',
    method: 'get',
    params: { pageNum, pageSize }
  })
}

// 获取考试记录详情
export function getExamRecordDetail(recordId) {
  return request({
    url: '/front/exam/record/' + recordId,
    method: 'get'
  })
}
